import axiosInstance from "../../../utils/axios";

const path = "/website" ; 
const commonPath= "common";

export const Banners = async (values) => {
    return await axiosInstance().get(`${path}/banners`, values);
}
export const FeaturedRestaurant = async (values) => {
    return await axiosInstance().get(`${path}/featured-restaurant`, values);
}

export const EnquiryForm = async (values) => {
    return await axiosInstance().post(`${path}/enquiry-form`, values);
}


export const Testimonials = async (values) => {
    return await axiosInstance().get(`${path}/testimonials`, values);
}

export const CMSOptions = async (values) => {
    return await axiosInstance().get(`${path}/cms-options?menu_location=${values}`);
}

    // ------------------------------------common-------------------------------------- //

export const GlobalSettingsDetails = async () => {
  return await axiosInstance().get(`${commonPath}/global-settings`);
};

export const CMSDetails = async (value) => {
  return await axiosInstance().get(`${commonPath}/cms-page?slug=${value}`);
};

export const GetMGPanels = async (slug) => {
  return await axiosInstance().get(`${path}/manual-guide/panels${slug?"/"+slug:""}`);
};

export const GetMGModules = async (slug, moduleSlug) => {
  return await axiosInstance().get(`${path}/manual-guide/modules/${slug}${moduleSlug?"/"+moduleSlug:""}`);
};

export const GetMGImages = async (panelSlug, moduleSlug) => {
  return await axiosInstance().get(`${path}/manual-guide/module-images/${panelSlug}/${moduleSlug}`);
};

